import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Input, Row, Col, Select, message, Spin } from 'antd';
import PropTypes from 'prop-types';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import DeleteConnectionPopup from './DeleteConnectionPopup';
import { getTriggerFiledforEntity, getAllUsersData } from '../../../Api/Services/CommonApiService'
import { FetchContactByAccount } from '../../../Api/Services/ContactApiService'
import { FetchAllAccount, AccountsByAccountType } from '../../../Api/Services/AccountApiService'
import { PriorityDealApi, massUpdateDeal, massDeleteDeals } from '../../../Api/Services/DealApiService'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Data from '../MassupdateJson/InLineEditFields.json'
import { ChangeOwnerIcon, SaveIcon, CancelIcon, DeleteIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

const Popup = ({ updatePopup, setUpdatePopup, dealIDs, GetAll, popupType, assignOwner, action, pageType, setStates, successMessage }) => {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const history = useHistory();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [fieldValue, setFieldValue] = useState(1)
    const [dealPriority, setDealPriority] = useState([])
    const [users, setUsers] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const localData = useSelector((state) => state.localRedux);
    const defaultCurrency = localData.currency
    const ProfileData = localData.profile
    const profile = ProfileData
    const [account, setAccount] = useState([])
    const [tagType, setTagType] = useState("Add")
    const [account2, setAccount2] = useState([])
    const [field1, setField1] = useState()
    const [errorData, setErrorData] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [editAttributes, setEditAttributes] = useState([])
    const [contactData, setContactData] = useState([])
    const [selectBoxes, setSelectBoxes] = useState([{ editedField: "dealOwner", editedValue: null }]);
    const [uiReady, setUiReady] = useState(false)
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    async function getAllAccoutbyType() {
        try {
            const data = await AccountsByAccountType()
            const option3 = data.filter((item) => item.account_type_name === "Competitor").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.account_name} (${option.account_number})`}>
                        {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                            < img src={option.account_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                            :
                            <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                {option?.account_name?.slice(0, 1).toUpperCase()}
                            </span>
                        }
                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option?.account_name?.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>))
            setAccount2(option3)
        }
        catch (error) {
            message.error(error)
        }
    }
    const AccountApi = async () => {
        try {
            const data = await FetchAllAccount()
            const option2 = data.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option?.account_name?.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.account_name}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option?.account_name?.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>))
            setAccount(option2)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleClose = () => {
        setUpdatePopup(false);
        if (pageType === "Listing") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (popupType !== "Delete") {
            // setState({ selectedRowKeys: [] })
        }
    }
    const handleChange = (value) => {
        setFieldValue(value)
    }
    const HandleIsModalVisible = (value) => {
        setUpdatePopup(value)
        setIsModalVisible(value)
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                    // <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    //     {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                    //         < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                    //         :
                    //         <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                    //             {option.firstName.slice(0, 1).toUpperCase()}
                    //         </span>
                    //     }
                    //     <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                    // </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        } catch (error) {
            message.error(error)
        }
    }
    async function PriorityApi() {
        try {
            const data = await PriorityDealApi()
            const options = data.map((option, i) => (
                <Option value={option.priorityId} key={i} >
                    {option.priorityName}
                </Option>));
            setDealPriority(options)
        } catch (error) {
            message.error(error)
        }
    }
    const allowedFields = {
        Deal: ['tags', 'accountName', 'dealOwner', 'priority', 'competition', 'contactPerson', 'expectedDealLength', 'winProbability', 'discountPercentage'],
    };
    async function Triggerfields() {
        try {
            const response = await getTriggerFiledforEntity("Deal")
            const orignal = response.filter(option =>
                allowedFields.Deal.includes(option.filedValue))
            setEditAttributes(orignal)
        } catch (error) {
            message.error(error)
        }
    }

    const getUserDetail = async () => {
        if (action === "SingleChangeOwner") {
            setField1(assignOwner)
            form.setFieldsValue({
                dealOwner: assignOwner
            });
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (profile.department === "Sales") {
                setField1(profile.userId)
                form.setFieldsValue({
                    dealOwner: profile.userId
                });
            }
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            Triggerfields(),
            getAllAccoutbyType(),
            UserDetailsApi(),
            AccountApi(),
            PriorityApi(),
        ])
        setUiReady(true)
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            getUserDetail()
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (updatePopup) {
            if (popupType === "Bulk Update") {
                fetchAll()
            }
            else if (popupType === "Change Owner") {
                fetchAll1()
            }
            else {
                setUiReady(true)
            }
        }
    }, [updatePopup])
    function RequiredValidity(queryData) {
        for (let i = 0; i < queryData.length; i += 1) {
            const query = queryData[i];
            if (!query.editedField) {
                return { isValid: false, message: 'Incomplete field(s)' };
            }
            const value = query.editedValue;

            const isValueEmpty = (!(query.editedField === "tags" && tagType === "Clear") &&
                (value === undefined ||
                    value === null ||
                    (typeof value === 'string' && value.trim() === '') ||
                    (Array.isArray(value) && value.length === 0)));
            if (query.visible !== 'No') {
                if (isValueEmpty) {
                    return { isValid: false, message: 'Incomplete field(s)' };
                }
            }
        }
        return { isValid: true };
    }
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const formData = {
            dealIds: dealIDs,
        }
        if (popupType === "Change Owner") {
            if (fieldValue === 1) {
                formData.dealOwner = field1;
            }
            const isAnyFieldUndefined = Object.values(formData).some(value => value === undefined);
            if (!isAnyFieldUndefined) {
                try {
                    const response = await massUpdateDeal(formData)
                    if (response.status === 200) {
                        if (action === "SingleChangeOwner") {
                            if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                                setErrorData(response.data);
                                setIsModalVisible1(true);
                                dispatch(setEditCall(false))
                                loadingRef.current = false;
                                setDelteClick(false)
                            }
                            else {
                                const isAutomation = response.data[0].message === AutomationMessage;
                                const isApproval = response.data[0].message === ApprovalMessage;
                                dispatch(setEditCall(false))
                                if (isApproval) {
                                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                                } else if (isAutomation) {
                                    successMessage("Automation rule triggered", response.data[0].message);
                                } else {
                                    message.success(
                                        <span>
                                            Deal <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                        </span>
                                    );
                                }
                                setUpdatePopup(false);
                                loadingRef.current = false;
                                setDelteClick(false)
                                if (!isApproval && assignOwner !== field1) {
                                    history.push('/Home/deals');
                                }
                                if (assignOwner === field1) {
                                    GetAll()
                                }
                            }
                        }
                        else {
                            const allUpdatedSuccessfully = response.data.every(item =>
                                item.message === "Deal Has Updated Successfully"
                            );
                            if (allUpdatedSuccessfully) {
                                dispatch(setEditCall(false))
                                if (pageType === "Listing") {
                                    setStates({
                                        selectedRows: [],
                                        selectedRowKeys: [],
                                    })
                                }
                                message.success("Data updated for selected records")
                                GetAll()
                                setUpdatePopup(false);
                                loadingRef.current = false;
                                setDelteClick(false)
                                return;
                            }
                            dispatch(setEditCall(false))
                            setErrorData(response.data);
                            setIsModalVisible1(true);
                            loadingRef.current = false;
                            setDelteClick(false)
                        }
                    }
                }
                catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    message.error(error)
                }
            } else {
                loadingRef.current = false;
                setDelteClick(false)
                // Handle the case where a field is undefined, e.g., show an error message.
                message.error("Field is Empty");
            }
        }
        if (popupType === "Bulk Update") {
            const validation = RequiredValidity(selectBoxes);
            if (!validation.isValid) {
                message.error(validation.message);
                loadingRef.current = false;
                setDelteClick(false)
                return;
            }
            const flatFields = selectBoxes.reduce((acc, item) => {
                const { editedField, editedValue, visible } = item;
                if (!editedField) return acc;
                if (editedField === "tags") {
                    acc[editedField] = tagType === "Clear" ? null : normalizeValue(editedValue);
                    acc.actionType = tagType;
                    return acc;
                }
                // CASE 1: visible === "No" → always include field
                if (visible === "No") {
                    acc[editedField] = Array.isArray(editedValue)
                        ? editedValue.join(',')
                        : normalizeValue(editedValue);
                    return acc;
                }
                // CASE 2: include only non-null values
                if (editedValue != null) {
                    acc[editedField] = Array.isArray(editedValue)
                        ? editedValue.join(',')
                        : normalizeValue(editedValue);
                }
                return acc;
            }, {});
            Object.assign(formData, flatFields);
            try {
                const response = await massUpdateDeal(formData)
                if (response.status === 200) {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.message === "Deal Has Updated Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        dispatch(setEditCall(false))
                        if (pageType === "Listing") {
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                        }
                        message.success("Data updated for selected records")
                        GetAll()
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    dispatch(setEditCall(false))
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
            } catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                message.error(error)
            }
        }
    }
    async function onDelete() {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const payload = {
            dealIds: dealIDs
        }
        try {
            const response = await massDeleteDeals(payload)
            if (response.status === 200) {
                if (popupType === "Delete") {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible(true);
                        dispatch(setEditCall(false))
                        loadingRef.current = false;
                        setDelteClick(false)
                    } else {
                        const isAutomation = response.data[0].entityMessage === AutomationMessage;
                        const isApproval = response.data[0].entityMessage === ApprovalMessage;
                        dispatch(setEditCall(false))
                        if (isApproval) {
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                        } else if (isAutomation) {
                            successMessage("Automation rule triggered", response.data[0].entityMessage);
                        } else {
                            message.success(
                                <span>
                                    Deal <strong>{response?.data?.[0]?.entityName}</strong> has been deleted successfully
                                </span>
                            );
                        }
                        history.push('/Home/deals')
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                    }
                } else {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.entityMessage === "Deal Has Deleted Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        dispatch(setEditCall(false))
                        message.success(`${dealIDs.length} record${dealIDs.length > 1 ? "s" : ""} deleted successfully`);
                        GetAll();
                        setStates({
                            selectedRows: [],
                            selectedRowKeys: [],
                        })
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    dispatch(setEditCall(false))
                    setErrorData(response.data);
                    setIsModalVisible(true);
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    const handleDealOwner = (value) => {
        setField1(value)
    }
    const getRefreshtheTable = () => {
        setUpdatePopup(false);
        if (popupType === "Bulk Delete") {
            GetAll();
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        } if (popupType === "Delete") {
            history.push('/Home/deals')
        }
    }
    const handleViewChange = async (index, fieldName, value, key, currecnyData) => {
        if (fieldName === "editedField" && value === "tags") {
            setTagType("Add")
        }
        let updatedFormData = [...selectBoxes];
        if (fieldName === "editedField") {
            const oldData = updatedFormData[index].editedField;
            if (oldData === "accountName") {
                updatedFormData = updatedFormData?.filter((item, idx) => {
                    if (idx === 0) return true;
                    return !["contactPerson"].includes(item.editedField);
                });
            }
            updatedFormData[index] = {
                ...updatedFormData[index],
                editedField: normalizeValue(value),
                editedValue: normalizeValue(value) === "competition" || normalizeValue(value) === "contactPerson" ? [] : null,
                Key: key,
                Currency: currecnyData
            };
            if (normalizeValue(value) === "accountName" || normalizeValue(value) === "contactPerson") {
                if (normalizeValue(value) === "accountName") {
                    const hasContact = updatedFormData.some(item => item.editedField === "contactPerson");
                    if (!hasContact) {
                        const contactInsert = {
                            editedField: "contactPerson",
                            editedValue: [],
                            Key: null,
                            Currency: null
                        };
                        const accountIndex = updatedFormData.findIndex(item => item.editedField === "accountName");
                        const insertAt = accountIndex >= 0 ? accountIndex + 1 : index;
                        updatedFormData.splice(insertAt, 0, contactInsert);
                        index = insertAt + 1;
                    }
                    setContactData([]);
                    // Optional: clear any old contact data
                    // updatedFormData = updatedFormData.map(item =>
                    //     (item.editedField === "contactPerson")
                    //         ? {
                    //             ...item, editedField: item.editedField, editedValue: []
                    //         }
                    //         : item
                    // );
                }
                if (normalizeValue(value) === "contactPerson") {
                    const hasCountry = updatedFormData.some(item => item.editedField === "accountName");
                    const inserts = [];
                    if (!hasCountry) {
                        inserts.push({
                            editedField: "accountName",
                            editedValue: null,
                            Key: null,
                            Currency: null
                        });
                    }
                    if (inserts.length > 0) {
                        updatedFormData.splice(index, 0, ...inserts);
                        index += inserts.length;
                    }
                }
            }
            else {
                updatedFormData = updatedFormData?.filter(
                    item => !["accountName", "contactPerson"].includes(item.editedField)
                );
            }
        }
        else {
            const editedFieldType = updatedFormData[index]?.editedField;
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                Key: key
            };
            if (editedFieldType === "accountName") {
                try {
                    const response = await FetchContactByAccount(normalizeValue(value))
                    setContactData(response)
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "contactPerson"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "contactPerson") {
                                return {
                                    ...item,
                                    editedValue: []
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "contactPerson",
                            editedValue: [],
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }

                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "contactPerson") {
                            return {
                                ...item,
                                editedValue: []
                            };
                        }
                        return item;
                    });
                    setContactData([])
                    message.error(error)
                }
            }
        }
        setSelectBoxes(updatedFormData);
    };
    const getAvailableOptions = (currentIndex) => {
        const selectedValues = selectBoxes.filter(box => box.visible !== "No").map(box => box.editedField).filter(value => value !== undefined);
        const AccessAttributes = editAttributes?.filter((item) => item.filedValue !== 'taskTypeId' && item.filedValue !== 'relatedToId' && item.filedValue !== 'tags' && item.filedValue !== "solution" && item.filedValue !== "comment" && item.filedValue !== "deal_description")
        return AccessAttributes.filter(option => !selectedValues.includes(option.filedValue) || selectBoxes[currentIndex].editedField === option.filedValue);
    };
    function getFieldTypeByValue(fieldValue) {
        const field = editAttributes.find(item => item.filedValue === fieldValue);
        return field ? field.FieldType : null;
    }
    const segBtn1 = (active) => ({ flex: 1, padding: "7px 0", fontSize: 12.5, fontWeight: 600, cursor: "pointer", borderRadius: 6, color: active ? "#407fe9" : "#8f8f8f", border: "none", background: active ? "white" : "transparent", });
    return (
        <>
            <Modal
                title={popupType}
                open={updatePopup}
                onCancel={handleClose}
                // centered
                maskClosable={false}
                footer={uiReady ? [
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        {popupType === "Bulk Update" &&
                            <>
                                <Button onClick={handleClose} size="small" className="gray-button" >
                                    <CancelIcon />Cancel
                                </Button>
                                <Button className='btn-add_new button_colors' size="small" onClick={onSubmit} disabled={deleteClick} loading={deleteClick}>
                                    {!deleteClick && <SaveIcon />}Update
                                </Button>
                            </>
                        }
                        {popupType === "Change Owner" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button htmlType="submit" className='btn-add_new button_colors' size="small" onClick={onSubmit} disabled={deleteClick} loading={deleteClick}>
                                    {!deleteClick && <ChangeOwnerIcon />}Change Owner
                                </Button>
                            </>
                        }
                        {popupType.includes("Delete") &&
                            <>
                                <Button htmlType="submit" className="gray-button" size="small" onClick={handleClose}>
                                    <CancelIcon /> Cancel
                                </Button>
                                <Button htmlType="submit" onClick={onDelete} size="small" className='red-button' disabled={deleteClick} loading={deleteClick}>
                                    {!deleteClick && <DeleteIcon />}{popupType}
                                </Button>
                            </>}
                    </div>
                ] : false}
            // width={600}
            > {uiReady ? <>
                {popupType === "Bulk Update" &&
                    (editAttributes.length > 0 ? <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="AccountMassUpdate" >
                                    {selectBoxes.filter((item) => item?.visible !== "No").map((selectbox, index) => {
                                        const filedType = getFieldTypeByValue(selectbox.editedField)
                                        return (
                                            <>
                                                <div style={{ padding: "0px 20px", display: selectbox.editedField !== 'tags' && "none" }}>
                                                    <div style={{ display: "flex", gap: 4, background: "#f7f7f7", borderRadius: 8, padding: 5, marginBottom: "0px 0px 20px" }}>
                                                        <button type="button" style={segBtn1(tagType === "Add")} onClick={() => setTagType("Add")}>Add tag</button>
                                                        <button type="button" style={segBtn1(tagType === "Remove")} onClick={() => setTagType("Remove")}>Remove tag</button>
                                                        <button type="button" style={segBtn1(tagType === "Clear")} onClick={() => {
                                                            setTagType("Clear");
                                                            setSelectBoxes(prev =>
                                                                prev.map(item =>
                                                                    item.editedField === "tags"
                                                                        ? { ...item, editedValue: "" }
                                                                        : item
                                                                )
                                                            );
                                                        }}>Clear all</button>
                                                    </div>
                                                </div>
                                                <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                                    <Col span={10}>
                                                        <Form.Item >
                                                            <Select style={{ width: '100%' }}
                                                                placeholder="Select Field"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                value={selectbox.editedField}
                                                                onChange={(record, option) => {
                                                                    const Key = option.FieldType
                                                                    const currecnyData = option.FieldData
                                                                    handleViewChange(index, 'editedField', record, Key, currecnyData);
                                                                }}
                                                                disabled={index !== 0}
                                                            >
                                                                {getAvailableOptions(index).map((option, idx) => (
                                                                    <Option value={option.filedValue} key={idx} FieldType={option.FieldType} FieldData={option.currencyType}>
                                                                        {option.fieldLable}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={14}>
                                                        <Form.Item key={index}>
                                                            {selectbox.editedField === 'tags' ?
                                                                <Select open={false}
                                                                    className="lead-tags-input"
                                                                    mode="tags"
                                                                    style={{ width: "100%" }}
                                                                    placeholder="Enter tags"
                                                                    tokenSeparators={[","]}
                                                                    value={selectbox.editedValue ? selectbox.editedValue.split(",").map((tag) => tag.trim()).filter(Boolean) : []}
                                                                    onChange={(value, option) => {
                                                                        handleViewChange(index, 'editedValue', value?.join(",") || "", filedType, selectbox.Currency, option);
                                                                    }}
                                                                />
                                                                : filedType === 'Drop Down' ? (
                                                                    <Select placeholder="Select Value"
                                                                        showSearch
                                                                        style={{ width: "100%" }}
                                                                        optionFilterProp="children"
                                                                        mode={(selectbox.editedField === "contactPerson" || selectbox.editedField === "competition") && 'multiple'}
                                                                        {...(selectbox.editedField === "dealOwner" || selectbox.editedField === "competition" || selectbox.editedField === "contactPerson" || selectbox.editedField === "accountName"
                                                                            ? { optionLabelProp: "label" } : {})}
                                                                        filterOption={(input, option) =>
                                                                            (selectbox.editedField === "dealOwner" || selectbox.editedField === "competition" || selectbox.editedField === "contactPerson" || selectbox.editedField === "accountName")
                                                                                ? (() => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                })()
                                                                                : option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        name="editedValue"
                                                                        value={selectbox.editedValue}
                                                                        onChange={(value, option) => {
                                                                            handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency, option);
                                                                        }}
                                                                    >
                                                                        {(selectbox.editedField === "dealOwner") &&
                                                                            users
                                                                        }
                                                                        {selectbox.editedField === "accountName" && <>
                                                                            {account}
                                                                        </>}
                                                                        {selectbox.editedField === "competition" && <>
                                                                            {account2}
                                                                        </>}
                                                                        {selectbox.editedField === "contactPerson" && <>
                                                                            {contactData.map((option, i) => (
                                                                                <Option value={option.contacts_id} key={i}
                                                                                    label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                                                                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                                < img src={option.contact_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option?.first_name?.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                        </div>)}>
                                                                                    <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                                                                        <div>
                                                                                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                                < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option?.first_name?.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }</div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                            <p style={{ margin: 0 }}>{option.email}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))}
                                                                        </>}
                                                                        {selectbox.editedField === "priority" && <>
                                                                            {dealPriority}
                                                                        </>}
                                                                    </Select>
                                                                ) : filedType === 'Free Text' || filedType === 'Numbers' ? (
                                                                    (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                        name="editedValue"
                                                                        prefix={selectbox.Currency === "YES" ? defaultCurrency?.symbol : (selectbox.editedField === "winProbability" || selectbox.editedField === "discountPercentage" || selectbox.editedField === "expectedDealLength") ? "%" : ""}
                                                                        value={selectbox.editedValue}
                                                                        onChange={(e) => {
                                                                            const inputValue = e.target.value;
                                                                              const decimalLimit = defaultCurrency?.decimalOfCurrency || 2;
                                                                            if (filedType === 'Numbers') {
                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                if (inputValue?.toString()?.length > 25) {
                                                                                    message.error('Maximum 25 characters allowed');
                                                                                    return;
                                                                                }
                                                                                if (!basicNumberCheck) {
                                                                                    message.error('Please enter a valid number');
                                                                                    return;
                                                                                }
                                                                                if (inputValue === ".") {
                                                                                    message.error('Please enter a valid number');
                                                                                    return;
                                                                                }
                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{1,${decimalLimit}})?$`);
                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                    message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                    return;
                                                                                }
                                                                                if (selectbox.editedField === "winProbability" || selectbox.editedField === "discountPercentage" || selectbox.editedField === "expectedDealLength") {
                                                                                    const num = Number(inputValue);
                                                                                    if (inputValue && (num < 0 || num > 100)) {
                                                                                        message.error('Percentage must be between 0 and 100');
                                                                                        return;
                                                                                    }
                                                                                }
                                                                            } else {
                                                                                const TotalLength = selectbox.editedField === "street" ? 100 : 50
                                                                                if (inputValue?.toString()?.length > TotalLength) {
                                                                                    message.error(`Maximum ${TotalLength} characters allowed`);
                                                                                    return;
                                                                                }
                                                                            }
                                                                            handleViewChange(index, 'editedValue', inputValue, filedType, selectbox.Currency);
                                                                        }} />
                                                                    ))
                                                                    : ""
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                </Row> </>
                                        )
                                    })}
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser> :
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "120px" }}>
                            <Spin />
                        </div>)
                }
                {popupType === "Change Owner" &&
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="Assignto" >

                                    <Row gutter={30} style={{ marginBottom: 20, marginTop: 20 }}>
                                        <Col span={10}>
                                            <Form.Item>
                                                <Select style={{ width: '100%' }}
                                                    placeholder="Select Field"
                                                    showSearch
                                                    disabled
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    value={fieldValue}
                                                    onChange={handleChange}
                                                >
                                                    {Data.Deal !== undefined && Data.Deal?.map((option, key) => (
                                                        <Option key={key} value={option.id}>
                                                            {option.filed}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={14}>
                                            {fieldValue === 1 &&
                                                <Form.Item name="dealOwner" id="dealOwner">
                                                    <Select style={{ width: '100%' }}
                                                        placeholder="Select Deal Owner"
                                                        showSearch optionLabelProp="label"
                                                        filterOption={(input, option) => {
                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                const username = String(usernameElement.props.children);
                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                            }
                                                            return false;
                                                        }
                                                        }
                                                        onChange={handleDealOwner}
                                                    >
                                                        {users}
                                                    </Select>
                                                </Form.Item>}
                                        </Col>
                                    </Row>
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser>
                }
                {popupType.includes("Delete") &&
                    < div >
                        <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                            {popupType === "Bulk Delete" && <p>Are you sure you want to delete the selected deals?</p>}
                            {popupType === "Delete" && <p>Are you sure you want to delete?</p>}
                        </div>
                    </div>
                } </> :
                <div className="spin" style={{ height: "250px" }}>
                    <Spin />
                </div>}
            </Modal >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page={pageType === "Listing" ? "DetailsError" : "Details"} type="Deal" getCallBack={getRefreshtheTable} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page={popupType === "Bulk Delete" ? "DetailsError" : "Details"} type="Deal" getCallBack={getRefreshtheTable} />}
        </>
    );
};

Popup.propTypes = {
    updatePopup: PropTypes.bool.isRequired,
    setUpdatePopup: PropTypes.func.isRequired,
    successMessage: PropTypes.func.isRequired,
    dealIDs: PropTypes.array.isRequired,
    GetAll: PropTypes.func.isRequired,
    setStates: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    assignOwner: PropTypes.number.isRequired,
    pageType: PropTypes.string.isRequired,
};

export default Popup;